import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SearchParams, ShAbstractHttpService } from '@stylehaven/components';

import { DigihavenEnvironmentConfig } from '../../entities/config/environment-config.entity';
import { ConfigService } from '../config/config.service';

@Injectable()
export class CoreHttpService extends ShAbstractHttpService {
    private apiUrl: string;

    constructor(
        private readonly http: HttpClient,
        private readonly configService: ConfigService<DigihavenEnvironmentConfig>
    ) {
        super();
        this.apiUrl = `${this.configService.config.apiUrl}`;
    }

    private getApiUrl() {
        return `${this.configService.config.apiUrl}`;
    }

    get<T>(endpoint: string, params?: SearchParams | HttpParams): Observable<T> {
        return this.http.get<T>(`${this.getApiUrl()}${endpoint}`, {
            params
        });
    }

    head<T>(endpoint: string, params?: SearchParams | HttpParams | undefined): Observable<HttpResponse<T>> {
        return this.http.head<T>(`${this.apiUrl}${endpoint}`, { params, observe: 'response' });
    }

    getBlob(endpoint: string): Observable<Blob> {
        return this.http.get<Blob>(`${this.apiUrl}${endpoint}`, {
            responseType: 'blob' as 'json'
        });
    }

    postBlob<T>(endpoint: string, data: any, headers?: HttpHeaders): Observable<T> {
        return this.http.post<T>(`${this.apiUrl}${endpoint}`, data, {
            responseType: 'blob' as 'json',
            headers: headers
        });
    }

    getExternal<T>(endpoint: string, responseType?: string): Observable<T> {
        return this.http.get<T>(`${endpoint}`, {
            ...(responseType && { responseType: responseType as 'json' })
        });
    }

    post<T>(endpoint: string, data: any, options?: {}): Observable<T> {
        return this.http.post<T>(`${this.getApiUrl()}${endpoint}`, data, options);
    }

    put<T>(endpoint: string, data: any): Observable<T> {
        return this.http.put<T>(`${this.apiUrl}${endpoint}`, data);
    }

    patch<T>(endpoint: string, data: any): Observable<T> {
        return this.http.patch<T>(`${this.apiUrl}${endpoint}`, data);
    }

    delete<T>(endpoint: string): Observable<T> {
        return this.http.delete<T>(`${this.apiUrl}${endpoint}`);
    }

    request<T>(endpoint: string, method: string, body: any): Observable<T> {
        return this.http.request<T>(method, `${this.apiUrl}${endpoint}`, { body });
    }

    count(endpoint: string, params?: HttpParams | SearchParams | undefined): Observable<number> {
        throw new Error('Method not implemented.');
    }

    getText<T>(endpoint: string, params?: HttpParams | SearchParams | undefined): Observable<string> {
        throw new Error('Method not implemented.');
    }

    postProgress<T>(endpoint: string, data: any): Observable<HttpEvent<T>> {
        throw new Error('Method not implemented.');
    }

    postResponse<T>(endpoint: string, data: any, headers?: HttpHeaders): Observable<HttpResponse<T>> {
        throw new Error('Method not implemented.');
    }

    patchResponse<T>(endpoint: string, data: any, headers?: HttpHeaders): Observable<HttpResponse<T>> {
        throw new Error('Method not implemented.');
    }

    getExternalBlob(url: string): Observable<Blob> {
        return this.http.get<Blob>(url, {
            responseType: 'blob' as 'json'
        });
    }
}
